<template>
    <div class="phoneCallDialog">
        <el-main>
            <el-row :gutter="32">
                <el-col :span="24">{{phoneCallDialog.title}}</el-col>
            </el-row>
            <el-row :gutter="32">
                <el-col :span="24" v-if="phoneCallDialog.readState === '1'">{{minute}} 分 {{second}} 秒</el-col>
            </el-row>
            <el-row :gutter="32">
                <el-col :span="24">{{phoneCallDialog.msgDetail}}</el-col>
            </el-row>
        </el-main>
    </div>    
</template>

<script>
export default {
    name: 'phoneCallDialog',
    props:[
        "phoneCallDialog"
    ],
    data(){
        return{
            phoneCallDialog:{
                title:'',
                readStateCn:'',
                time: '',
                msgDetail: '',
                minute: 0,
                second: 0,
                timer: '',
            }
        }
    },
    created(){
        let _this = this;
        _this.timer = setInterval(_this.time, 1000);
    },
    methods: {
        time(){
            let _this = this;
            if(_this.phoneCallDialog.calTime === 0){
                _this.minute = 0;
                _this.second = 0;
                _this.phoneCallDialog.calTime = 1;
            }
            if(_this.second !== 0 && _this.second % 60 === 0){
                _this.minute++;
                _this.second = 0;
            } else{
                _this.second++;
            }
        }
    },
    
}
</script>
<style lang="less">
.phoneCallDialog{
    .el-main{
        text-align: center;
        color: red;
        .el-row{
            margin:10px !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/phoneCallDialog/phoneCallDialog.vue